import { Container } from '@repo/ui'
import { cn } from '@repo/ui/lib/utils'
import type React from 'react'

interface FooterLayoutProps {
  className?: string
  children: React.ReactNode
}

export const FooterLayout: React.FC<FooterLayoutProps> = ({ className, children }) => {
  return (
    <footer className={cn('web-footer-field relative pt-0', className)}>
      <Container size="content" className="relative z-10 pb-6">
        {children}
      </Container>
    </footer>
  )
}
